"use client";
import React from 'react';
import './ClaimInformation.css';
import PropTypes from 'prop-types';
import { Button } from 'atm-global-stylish/dist';
import { ReactComponent as Document } from '../../assets/img/Document.svg';
import { ReactComponent as DocumentWarning } from '../../assets/img/DocumentWarning.svg';
import { ReactComponent as LightBulb } from '../../assets/img/LightBulb.svg';
const ClaimInformation = ({sinisterType, handleInitClaim}) => {
	let title = ''
	switch (sinisterType) {
		case 0:
			title = 'como peatón'
			break;
		case 1:
			title = 'como ciclista u otra movilidad sustentable'
			break;
		case 2:
			title = 'por daños en tu vehículo'
			break;
		case 3:
			title = 'como motociclista'
			break;
		case 4:
			title = 'por daños en tu inmueble'
			break;
		default:
			break;
	}
	return (
		<div className='w-full'>
			<div className='w-full max-w-2xl mt-5 mx-auto px-6 py-10 flex flex-col gap-6 text-black text-base'>
				<div className="font-bold text-red">Para iniciar el reclamo {title} debes contar con:</div>
				{sinisterType === 0 && 
					<div className="w-full mx-auto">
						<div className='mt-2'>
							<h2 className="font-bold text-red">Datos del Asegurado en ATM Seguros:</h2>
							<ul className="list-disc list-inside mt-1">
								<li> DNI, Nro. de siniestro, póliza o patente.</li>
							</ul>
						</div>

						<div className='mt-2'>
							<h2 className="font-bold text-red">Tus datos personales:</h2>
							<ul className="list-disc list-inside mt-1">
								<li>Nombre y apellido, DNI, domicilio y teléfonos de contacto y email. </li>
							</ul>
						</div>

						<div className='mt-2'>
							<h2 className="font-bold text-red">Datos del siniestro:</h2>
							<ul className="list-disc list-inside mt-1">
								<li>Fecha y hora, dirección y forma de ocurrencia. </li>
							</ul>
						</div>

						<div className='mt-2'>
							<h2 className="font-bold text-red">
								La siguiente documentación digitalizada <span className="italic text-black">(en fotos o escaneada)</span>:
							</h2>
							<ul className="list-disc list-inside mt-1">
								<li>Certificados/constancias de lesiones.</li>
								<li>DNI del dueño (frente y dorso)</li>
								<li>Nota explicando forma de ocurrencia del siniestro y las calles en las que transcurre.</li>
							</ul>
						</div>
					
						<div className="flex items-start gap-5 my-3">
							<DocumentWarning className="w-24 -ml-5" />

							<p>
								<span className="text-red font-bold">La documentación debe ser cargada en formato PDF o JPG y no deberá pesar más de "1 MB"</span>
							</p>
						</div>
					</div>
				}
				{sinisterType === 1 &&
					<div className="w-full mx-auto">
						<div className='mt-2'>
							<h2 className="font-bold text-red">Datos del Asegurado en ATM Seguros:</h2>
							<ul className="list-disc list-inside mt-1">
								<li> DNI, Nro. de siniestro, póliza o patente.</li>
							</ul>
						</div>

						<div className='mt-2'>
							<h2 className="font-bold text-red">Tus datos personales:</h2>
							<ul className="list-disc list-inside mt-1">
								<li>Nombre y apellido, DNI, domicilio y teléfonos de contacto y email. </li>
							</ul>
						</div>

						<div className='mt-2'>
							<h2 className="font-bold text-red">Datos del siniestro:</h2>
							<ul className="list-disc list-inside mt-1">
								<li>Fecha y hora, dirección y forma de ocurrencia. </li>
							</ul>
						</div>

						<div className='mt-2'>
							<h2 className="font-bold text-red">
								La siguiente documentación digitalizada <span className="italic text-black">(en fotos o escaneada)</span>:
							</h2>
							<ul className="list-disc list-inside mt-1">
								<li>Certificados/constancias de lesiones.</li>
								<li>DNI del dueño (frente y dorso)</li>
								<li>Nota explicando forma de ocurrencia del siniestro y las calles en las que transcurre.</li>
								<li>Presupuesto de reparación.</li>
							</ul>
						</div>
					
						<div className='mt-2'>
							<h2 className="font-bold text-red">Lesionados:</h2>
							<ul className="list-disc list-inside mt-1">
								<li>DNI (Frente y dorso) y certificados médicos/constancias de lesiones. </li>
							</ul>
						</div>

						<div className="flex items-start gap-5 my-3">
							<DocumentWarning className="w-24 -ml-5" />
							<p>
								<span className="text-red font-bold">La documentación debe ser cargada en formato PDF o JPG y no deberá pesar más de "1 MB"</span>
							</p>
						</div>
					</div>
				}
				{(sinisterType === 2 || sinisterType === 3) &&
					<div className="w-full mx-auto">
						<div className='mt-2'>
							<h2 className="font-bold text-red">Datos del Asegurado en ATM Seguros (segun el tipo de siniestro elegido):</h2>
							<ul className="list-disc list-inside mt-1">
								<li>DNI, Nro de siniestro o póliza, Patente</li>
							</ul>
						</div>
						<div className='mt-2'>
							<h2 className="font-bold text-red">
								La siguiente documentación digitalizada <span className="italic text-black">(en fotos o escaneada)</span>:
							</h2>
							<ul className="list-disc list-inside mt-1">
								<li>Denuncia Administrativa realizada en tu compañía de seguros.</li>
								<li>Certificado de cobertura otorgado por tu compañía a la fecha del siniestro.</li>
								<li>Registro del conductor de la moto al momento del siniestro (Frente y dorso).</li>
								<li>Cédula verde o título de propiedad del automotor. (Frente y dorso)</li>
								<li>DNI del dueño (frente y dorso)</li>
								<li>Fotos de la moto y/o del siniestro <span className="italic">(link a recomendaciones fotos)</span></li>
							</ul>
						</div>
						<div className='mt-2'>
							<h2 className="font-bold text-red">Lesionados:</h2>
							<ul className="list-disc list-inside mt-1">
								<li>DNI (Frente y dorso) y certificados médicos/constancias de lesiones.</li>
							</ul>
						</div>
						<div className="flex items-start gap-5 my-3">
							<Document className="w-24 -ml-2" />

							<p>
								<span className="text-red font-bold">IMPORTANTE:</span> En las fotos deben observarse claramente los daños,
								conjuntamente con la patente y el vehículo completo a fin de poder identificar y relacionar los daños con la unidad reclamante.
							</p>
						</div>				
						<div className="flex items-start gap-5 my-3">
							<DocumentWarning className="w-24 -ml-5" />

							<p>
								<span className="text-red font-bold">La documentación debe ser cargada en formato PDF o JPG y no deberá pesar más de "1 MB"</span>
							</p>
						</div>
						<div className="flex items-start gap-5 my-3">
							<LightBulb className="w-24 " />

							<p>
								<span className="text-red font-bold">Recomendaciones para sacar fotos de los daños:</span><br />
								Saca las fotos desde una perspectiva donde pueda verse el daño y el vehículo completo con la patente,
								esto permitirá que la gestión del reclamo sea más rápida y precisa.
								Luego toma algunas fotos de otros detalles que creas necesarios ampliar acercando la imagen a los mismos.
							</p>
						</div>
					</div>
				}
				{sinisterType === 4 &&
					<div className="w-full mx-auto">
						<div className='mt-2'>
							<h2 className="font-bold text-red">Datos del Asegurado en ATM Seguros:</h2>
							<ul className="list-disc list-inside mt-1">
								<li> DNI, Nro. de siniestro, póliza o patente.</li>
							</ul>
						</div>

						<div className='mt-2'>
							<h2 className="font-bold text-red">Tus datos personales:</h2>
							<ul className="list-disc list-inside mt-1">
								<li>Nombre y apellido, DNI, domicilio y teléfonos de contacto y email. </li>
							</ul>
						</div>

						<div className='mt-2'>
							<h2 className="font-bold text-red">Datos personales del tercero reclamante:</h2>
							<ul className="list-disc list-inside mt-1">
								<li>Nombre y apellido, DNI, domicilio y teléfonos de contacto y email.  </li>
								<li>Si tenés seguro sobre tu propiedad indica tu compañía aseguradora y el riesgo cubierto.   </li>
							</ul>
						</div>

						<div className='mt-2'>
							<h2 className="font-bold text-red">
								La siguiente documentación digitalizada <span className="italic text-black">(en fotos o escaneada)</span>:
							</h2>
							<ul className="list-disc list-inside mt-1">
								<li>DNI del dueño (frente y dorso)</li>
								<li>Fotos de la propiedad y/o del siniestro (deben observarse los daños).</li>
								<li>Escritura y/o contrato de alquiler.</li>
								<li>Presupuestos de reparación.</li>
								<li>Si tenés seguro, la Denuncia Administrativa realizada en tu compañía y certificado de cobertura otorgado por tu compañía a la fecha del siniestro.</li>
							</ul>
						</div>

						<div className="flex items-start gap-5 my-3">
							<DocumentWarning className="w-24 -ml-5" />
							<p>
								<span className="text-red font-bold">La documentación debe ser cargada en formato PDF o JPG y no deberá pesar más de "1 MB"</span>
							</p>
						</div>
					</div>
				}
			</div>
			<div className="w-full flex justify-center items-center mx-auto">
				<img src={require('../../assets/img/cars-img.jpg')} className='w-52 mx-auto' alt='Reclamos'/>
			</div>
			<div className='w-11/12 m-auto'>
				<p id="anchor_documentacion" className="text-center text-2xl font-semibold text-red mt-4">
					¿Contás con toda la documentación necesaria para ingresar el reclamo?
				</p>
				<div className='text-center md:w-1/3 m-auto items-center my-7'>
					<Button type='primary' title='Iniciá tu reclamo' className='w-full p-2 md:p-3 transition' handleClick={() => handleInitClaim()} />
				</div>
				<div className='md:w-1/3 m-auto hidden'>
					<Button type='secondary' title='Descargar la información' className='w-auto p-2 md:p-3 transition h-auto flex-wrap border border-red' />
				</div>
			</div>
 		</div>
	);
};

ClaimInformation.propTypes = {
	sinisterType: PropTypes.number,
	handleInitClaim: PropTypes.func
};

export default ClaimInformation;